interface MicromagStudioIconProps {
    color?: string;
    className?: string;
}

const MicromagStudioIcon = ({
    color = 'currentColor',
    className = null,
}: MicromagStudioIconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 315.77 56.94" className={className}>
        <path
            fill={color}
            d="m34.3.69v55.55h-10.42v-23.82l-4.31,23.82h-4.86l-4.31-23.82v23.82H0V.69h10.42l6.74,32.08L23.89.69h10.42Z"
        />
        <path fill={color} d="m46.8.69v55.55h-10.42V.69h10.42Z" />
        <path
            fill={color}
            d="m64.57,16.53c0-4.72-.35-6.11-2.64-6.11s-2.64,1.39-2.64,6.11v23.89c0,4.72.35,6.11,2.64,6.11s2.64-1.39,2.64-6.11v-6.74h10.42v7.43c0,11.18-4.65,15.83-13.05,15.83s-13.05-4.65-13.05-15.83V15.83c0-11.18,4.65-15.83,13.05-15.83s13.05,4.65,13.05,15.83v7.43h-10.42v-6.74Z"
        />
        <path
            fill={color}
            d="m104.08,56.24h-10.42c-.69-.83-.76-2.85-.76-4.93v-10.69c0-4.03-1.39-4.72-5.42-4.72v20.35h-10.42V.69h10.42c11.87,0,15.83,3.96,15.83,15.14v4.93c0,6.11-1.87,10.07-5.14,12.43,3.54,1.46,5.14,4.31,5.14,9.51v8.61c0,2.08.07,4.1.76,4.93Zm-16.6-45.13v14.37c4.03,0,5.42-.69,5.42-4.72v-4.93c0-4.03-1.39-4.72-5.42-4.72Z"
        />
        <path
            fill={color}
            d="m173.63.69v55.55h-10.42v-23.82l-4.31,23.82h-4.86l-4.31-23.82v23.82h-10.42V.69h10.42l6.74,32.08L163.22.69h10.42Z"
        />
        <path
            fill={color}
            d="m191.68,46.8h-5.49l-.76,9.44h-10.42L181.82.69h14.23l6.81,55.55h-10.42l-.76-9.44Zm-.83-10.42l-1.87-24.65-1.94,24.65h3.82Z"
        />
        <path
            fill={color}
            d="m219.25,23.26v-6.74c0-4.72-.42-6.11-2.64-6.11s-2.64,1.39-2.64,6.11v23.89c0,4.72.35,6.11,2.64,6.11s2.64-1.39,2.64-6.11v-2.57h-2.64v-10.42h13.05v28.82h-4.17l-1.67-3.96c-2.15,2.71-5.07,4.65-8.82,4.65-7.5,0-11.46-4.65-11.46-15.83V15.83c0-11.18,4.65-15.83,13.05-15.83s13.05,4.65,13.05,15.83v7.43h-10.42Z"
        />
        <rect fill={color} x="105.65" y=".69" width="31.25" height="55.55" rx="3" ry="3" />
        <path
            fill={color}
            d="m304.96,7.72c-2.02,0-2.55,1.05-2.55,4.29v13.04c0,3.24.52,4.29,2.55,4.29s2.55-1.05,2.55-4.29v-13.04c0-3.24-.52-4.29-2.55-4.29Z"
        />
        <path
            fill={color}
            d="m283.9,8.07h-.7v20.93h.7c3.42,0,4.46-.52,4.46-3.94v-13.04c0-3.42-1.05-3.94-4.46-3.94Z"
        />
        <path
            fill={color}
            d="m313.68.68h-75.86c-1.15,0-2.08.93-2.08,2.08v31.54c0,1.15.93,2.08,2.08,2.08h75.86c1.15,0,2.08-.93,2.08-2.08V2.76c0-1.15-.93-2.08-2.08-2.08Zm-67,32.15c-4.53,0-6.31-2.34-6.31-9.87h3.49c0,5.34.77,6.38,2.83,6.38,1.64,0,2.27-.84,2.27-3.77s-.98-4.19-3.56-6.21c-2.48-1.92-4.85-3.84-4.85-8.41,0-4.12,1.74-6.73,5.79-6.73s5.93,2.62,5.93,8.48h-3.49c0-4.19-.94-4.99-2.44-4.99s-2.3.8-2.3,3.24,1.22,3.77,3.28,5.34c2.96,2.27,5.13,4.22,5.13,9.28,0,4.6-1.67,7.25-5.75,7.25Zm17.82-24.76h-3.94v24.41h-3.49V8.07h-3.94v-3.49h11.37v3.49Zm13.46,16.99c0,5.62-1.99,7.78-6.03,7.78s-6.03-2.16-6.03-7.78V4.58h3.49v20.47c0,3.24.52,4.29,2.55,4.29s2.55-1.05,2.55-4.29V4.58h3.49v20.47Zm13.88,0c0,6.03-2.34,7.43-7.95,7.43h-4.19V4.58h4.19c5.62,0,7.95,1.33,7.95,7.43v13.04Zm5.33,7.43h-3.49V4.58h3.49v27.9Zm13.81-7.43c0,5.62-1.99,7.78-6.03,7.78s-6.03-2.16-6.03-7.78v-13.04c0-5.62,1.99-7.78,6.03-7.78s6.03,2.16,6.03,7.78v13.04Z"
        />
    </svg>
);

export default MicromagStudioIcon;
